const usingServiceAdvantage = {
  en: {
    title: 'Serve Boba Faster Than Ever Before',
    desc: 'Save minutes off every order',
    items: [
      {
        title: 'Empower the Guests with Self Service',
        image: `${process.env.ASSETS_PREFIX}/businesstype/customers-ordering-from-boba-shop-kiosk-pos.jpeg`,
        items: [
          {
            desc: 'Speed up delivery and accuracy for every Boba order',
          },
          {
            desc: 'Self-serve kiosks make peak hours more profitable and less hectic',
          },
          {
            desc: 'Save big on labor, while upgrading the customer experience!',
          },
        ],
      },
      {
        title: 'More Sales from Streamlined Boba ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/happy-boba-tea-customer.jpg`,
        items: [
          {
            desc: 'Cut order wait-times in half with self-ordering!',
          },
          {
            desc: 'Self-service generates higher order volume, higher table turn over, and happier customers',
          },
        ],
      },
      {
        title: 'More Speed, More Profits',
        image: `${process.env.ASSETS_PREFIX}/businesstype/bobatea-service-type_usage_03.jpeg`,
        items: [
          {
            desc: 'Our POS system saves the average restaurant up to $8,000/month in labor costs',
          },
          {
            desc: 'Remove redundant costly tasks, which can boost sales volume, tips, staff productivity, and your bottom line!',
          },
        ],
      },
    ],
  },
  zh: {
    title: '更快的出餐速度',
    desc: '使用Chowbus POS，缩短出餐时间至几十秒',
    items: [
      {
        title: '提升顾客点单效率',
        image: `${process.env.ASSETS_PREFIX}/businesstype/customers-ordering-from-boba-shop-kiosk-pos.jpeg`,
        items: [
          {
            desc: '到店的顾客可以使用二维码、智能自助点餐机等自助下单，减少等待点餐的时间',
          },
          {
            desc: '顾客还可以用网页随时随地地下单、支付，收到餐品完成的短信后，到店立即可取',
          },
        ],
      },
      {
        title: '降低餐厅服务难度 ',
        image: `${process.env.ASSETS_PREFIX}/businesstype/happy-boba-tea-customer.jpg`,
        items: [
          {
            desc: '无论是店内自助点餐还是线上订单，顾客自助点餐、支付，减少人力成本',
          },
          {
            desc: '订单直达后厨，无需人工传达订单，店员可以专注在餐品制作，提升出餐速度，创造更多营业额',
          },
          {
            desc: '集成第三方外卖平台，所有外卖订单直达厨房，无需额外的人力投入',
          },
        ],
      },
      {
        title: '升级餐厅管理体验',
        image: `${process.env.ASSETS_PREFIX}/businesstype/bobatea-service-type_usage_03.jpeg`,
        items: [
          {
            desc: '餐厅可以一站式管理各个点餐渠道的菜单、价格，降低维护投入',
          },
          {
            desc: '通过每日数据概览，随时随地了解营业额、营业额来源及成本数据',
          },
        ],
      },
    ],
  },
};

export default usingServiceAdvantage;
